export class Coop {
    coop: number;
    coopPercent:  number;
    constructor(coop,coopPercent) {
        this.coop = coop;
        this.coopPercent = coopPercent;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/rtb/info/class/coop.ts